<template>
    <header
        v-if="
            ![
                'createSimpleViewExperienceV3',
                'editSimpleViewExperienceV3',
                'createTreatmentV3',
                'editTreatmentV3',
                'createViewExperienceV3',
                'editViewExperienceV3',
                'editPackageV3',
                'createPackageV3',
                'indexViewProductCategoryV3',
                'indexViewProductBrandV3',
                'indexViewProductSupplierV3',
                'indexViewProductV3',
                'indexViewFoodV3',
                'createViewFoodV3',
                'editViewFoodV3',
                'createProductV3',
                'editProductV3',
                'getCustomersBOV3',
                'adminPlanning',
                'createSerieV3',
                'editSerieV3',
            ].includes(currentRoute)
        "
        id="page-header"
        class="sticky top-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm transition-all duration-300"
        :style="{ paddingLeft: normalizeSize(55), paddingRight: normalizeSize(55) }"
    >
        <div
            class="d-flex flex-row align-items-center"
            :style="{
                marginTop: '10px',
                marginBottom: normalizeSize(20, true),
                paddingTop: '10px',
            }"
        >
            <h4
                class="ppv2-text-black poppinsRegular uppercaseFirstLetter my-0 title-header"
                :style="{ fontSize: normalizeFontSize(26) }"
            >
                {{ $t(currentIcon.title) }}
            </h4>
        </div>
    </header>
</template>

<script>
// Import de la fonction depuis le fichier utils
import normalizeSize from '../../utils/normalizeSize'
import normalizeFontSize from '../../utils/normalizeFontSize'

export default {
    name: 'PageHeader',
    props: {
        currentRoute: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            // Mapping des routes vers les titres
            routeIcons: {
                adminHome: {
                    title: 'header.titles.adminHome',
                },
                adminPlanning: {
                    title: 'header.titles.adminPlanning',
                },
                getCheckouts: {
                    title: 'header.titles.getCheckouts',
                },
                getCustomersBOV2: {
                    title: 'header.titles.getCustomersBOV2',
                },
                getDevis: {
                    title: 'header.titles.getDevis',
                },
                getInvoices: {
                    title: 'header.titles.getInvoices',
                },
                getPromotions: {
                    title: 'header.titles.getPromotions',
                },
                newsletters_index: {
                    title: 'header.titles.newsletters_index',
                },
                getMailsCustoms: {
                    title: 'header.titles.getMailsCustoms',
                },
                notifications_index: {
                    title: 'header.titles.notifications_index',
                },
                blog_list: {
                    title: 'header.titles.blog_list',
                },
                staffPlanning: {
                    title: 'header.titles.staffPlanning',
                },
                getStaffs: {
                    title: 'header.titles.getStaffs',
                },
                getRoles: {
                    title: 'header.titles.getRoles',
                },
                GamificationViewAll: {
                    title: 'header.titles.GamificationViewAll',
                },
                getStats: {
                    title: 'header.titles.getStats',
                },
                editViewEstablishmentV2: {
                    title: 'header.titles.editViewEstablishmentV2',
                },
                list_categ: {
                    title: 'header.titles.list_categ',
                },
                getSpaces: {
                    title: 'header.titles.getSpaces',
                },
                getWebsiteSettings: {
                    title: 'header.titles.getWebsiteSettings',
                },
                websiteSettingsV3: {
                    title: 'Paramètres',
                },
                widgets_index: {
                    title: 'header.titles.widgets_index',
                },
                getProduit: {
                    title: 'header.titles.getProduit',
                },
                bo_foods_index: {
                    title: 'header.titles.bo_foods_index',
                },
                google_calendar: {
                    title: 'header.titles.google_calendar',
                },
                adminIndexPos: {
                    title: 'header.titles.adminIndexPos',
                },
                adminIndexApplication: {
                    title: 'header.titles.adminIndexApplication',
                },
                getInvoicesV2: {
                    title: 'header.titles.getInvoicesV2',
                },
                getInvoicesV3: {
                    title: 'header.titles.getInvoicesV3',
                },
                getInvoicesEnAttente: {
                    title: 'header.titles.getInvoicesEnAttente',
                },
                indexViewExperienceV3: {
                    title: 'header.titles.indexViewExperienceV3',
                },
                indexViewEquipementsV3: {
                    title: 'header.titles.indexViewEquipementsV3',
                },
                indexViewFoodV3: {
                    title: 'header.titles.indexViewFoodV3',
                },
                indexViewProductV3: {
                    title: 'header.titles.indexViewProductV3',
                },
                createProductV3: {
                    title: 'header.titles.createProductV3',
                },
                editProductV3: {
                    title: 'header.titles.editProductV3',
                },
            },
        }
    },

    computed: {
        // Icône et titre courants
        currentIcon() {
            return this.routeIcons[this.currentRoute.replace(/[.\-]/g, '_')] || { title: 'header.titles.default' }
        },
    },

    methods: {
        normalizeFontSize,
        normalizeSize,
    },
}
</script>

<style scoped>
.icon-header {
    flex-shrink: 0;
}
</style>
